import { Link } from "react-router-dom";
import { back } from "../../asset";

const AttendanceHeader = () => {
  const legends = [
    { label: "Present", code: "P", color: "text-success-700" },
    { label: "Absent", code: "Ab", color: "text-error-600" },
    { label: "Weekend", code: "W", color: "text-warning-400" },
    { label: "Holiday", code: "H", color: "text-primary-500" },
    { label: "Half Day", code: "HD", color: "text-netural-500" },
  ];

  return (
    <div className="flex justify-between items-center">
      <Link to="/" className="flex items-center gap-2 group">
        <img src={back} alt="back" className="w-4 h-4" />
        <span className="text-primary-600 underline text-[12px] font-medium group-hover:text-primary-700">
          Back to home
        </span>
      </Link>

      <div className="flex items-center gap-6">
        <div className="flex gap-4 text-sm font-semibold">
          {legends?.map((item) => (
            <span
              key={item.code}
              className={`${item.color} border-r border-neutral-100 pr-3 last:border-none`}
            >
              {item.code} - {item.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AttendanceHeader;
